<template>
  <div class="home">
    <h1>Choose an option below:</h1>
    <button @click="goTo('UploadJson')">
      <img height="50" src="@/assets/json-uploader.png" />
    </button>
    <button @click="goTo('EditSnps')">
      <img height="50" src="@/assets/snp-editor.png" />
    </button>
    <button @click="goTo('UploadImage')">
      <img height="50" src="@/assets/image-uploader.png" />
    </button>
  </div>
</template>

<script>
export default {
  name: "TheHome",
  data() {
    return {};
  },
  methods: {
    // This workaround is more or less to preserve Miso's button styling,
    // rather than switch the element to a router-link
    goTo(path) {
      this.$router.push({ name: path });
    }
  }
};
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-image: url("../assets/pikachubg.jpg");
  background-position-y: bottom;
}

button {
  margin: 0 40vw 1vw;
  cursor: pointer;
  background: #ffe664;
  border: 3px solid black;
  border-radius: 5px;
  width: 20vw;
}

button:hover {
  background-color: red;
  cursor: pointer;
}
</style>
